import Helper from "./Helper";

class Sidenav {
  constructor(config = {}) {
    const { sidenavIndicatorSelector } = config;
    this.sidenavIndicatorSelector =
      sidenavIndicatorSelector || ".js-in-sidenav";
    this.sideNavIndicator = Array.prototype.slice.call(
      document.querySelectorAll(this.sidenavIndicatorSelector)
    );

    if (this.sideNavIndicator.length > 0) {
      this.buildSideNav();
    }
  }

  buildSideNav() {
    const wrapper = document.createElement("div");
    Helper.addClass(wrapper, "sidenav");

    this.sideNavIndicator.forEach((el, i) => {
      const sidenavAnchor = document.createElement('a');
      Helper.addClass(sidenavAnchor, 'ns-anchor');
      sidenavAnchor.id = "sidenav-element-" + i;
      Helper.addBefore(sidenavAnchor, el);
      const title = el.innerText;
      const element = document.createElement("a");
      Helper.addClass(element, "sidenav__element");
      element.href = "#sidenav-element-" + i;
      element.innerHTML = `<span class="sidenav__bullet"></span><span class="sidenav__text">${title}</span>`;
      wrapper.appendChild(element);
    });

    document.querySelector("body").appendChild(wrapper);
  }
}
export default Sidenav;
